<script>
  import * as THREE from "three";
  import { easeQuadInOut } from "d3";
  import { nPointsGeometry, nPointsCircle } from "../utils/geometries";
  import { getContext } from "svelte";
  import { time } from "../stores/global";
  import viewport from "../stores/viewport.js";
  import vertexShader from "../shaders/moon-vertex.glsl";
  import fragmentShader from "../shaders/moon-fragment.glsl";

  export let percentage;
  export let planet;
  export let opacity;
  export let radius;
  export let index;

  const { FOV, FAR, PIXEL_RATIO, RADIUS } = getContext("Universe");

  const borderPoints = 100;
  const borderRadius = (radius || RADIUS) * 1.4;
  const backgroundRadius = (radius || RADIUS) * 1.4;
  const backgroundMaxOpacity = 0.7;

  const lod = new THREE.LOD();
  let countId, displayId;

  const tweenValue = function (unif, targetVal, speed, id, round = true) {
    window.cancelAnimationFrame(id);
    let time = 0;
    const initialVal = material.uniforms[unif].value;
    const incrementTweenVar = () => {
      if (time + speed < 1) {
        const progress = easeQuadInOut(time);
        const setVal = targetVal * progress + initialVal * (1 - progress);
        if (round) {
          material.uniforms[unif].value = Math.round(setVal);
        } else {
          material.uniforms[unif].value = setVal;
        }

        id = window.requestAnimationFrame(incrementTweenVar);
        time += speed;
      } else {
        material.uniforms[unif].value = targetVal;
      }
    };
    id = window.requestAnimationFrame(incrementTweenVar);
  };

  const uniforms = {
    uTime: {
      value: $time,
    },
    uResolution: {
      value: {
        x: $viewport.width,
        y: $viewport.height,
      },
    },
    uPixelRatio: {
      value: PIXEL_RATIO,
    },
    uRad: {
      value: borderRadius,
    },
    uFov: {
      value: FOV,
    },
    uGlowNum: {
      value: Math.floor(percentage * 100),
    },
    uOpacity: {
      value: 1,
    },
    uDisplay: {
      value: percentage ? 1 : 0,
    },
    uNearOpacity: {
      value: opacity,
    },
    uAdjustAspectRatio: {
      value: 1,
    },
    uBaseSize: {
      value: 2,
    },
  };

  const material = new THREE.ShaderMaterial({
    transparent: true,
    uniforms: uniforms,
    vertexShader: vertexShader,
    fragmentShader: fragmentShader,
  });

  // const alphaTex = new THREE.TextureLoader().load(
  //   "assets/textures/alphaMap.png"
  // );
  const bgMaterial = new THREE.MeshLambertMaterial({
    color: "black",
    // alphaMap: alphaTex,
    transparent: true,
    opacity: opacity * backgroundMaxOpacity,
  });

  const bdMaterial = new THREE.PointsMaterial({
    color: 0x999999,
    size: 0.8,
    sizeAttenuation: false,
    transparent: true,
    opacity: opacity,
  });

  const counts = [102, 0];
  for (let i = 0; i < counts.length; i++) {
    const lodGroup = new THREE.Group();

    const geometry = nPointsGeometry(counts[i]);
    const points = new THREE.Points(geometry, material);
    lodGroup.add(points);

    if (i === 0) {
      const bgGeometry = new THREE.CircleBufferGeometry(backgroundRadius, 64);
      const bgMesh = new THREE.Mesh(bgGeometry, bgMaterial);
      bgMesh.userData = { index };
      bgMesh.position.set(0, 0, -0.1);
      lodGroup.add(bgMesh);

      const bdGeometry = nPointsCircle(borderPoints, borderRadius);
      const bdMesh = new THREE.Points(bdGeometry, bdMaterial);
      lodGroup.add(bdMesh);
    }

    const level = Math.floor(((i / 3) * FAR) / counts.length);
    lod.addLevel(lodGroup, level);
  }

  planet.add(lod);

  $: {
    material.uniforms.uNearOpacity.value = opacity;
    bgMaterial.opacity = opacity * backgroundMaxOpacity;
    bdMaterial.opacity = opacity;
  }

  $: {
    material.uniforms.uTime.value = $time;
  }

  $: {
    material.uniforms.uResolution.value = {
      x: $viewport.width,
      y: $viewport.height,
    };
  }

  $: {
    if (percentage !== undefined) {
      tweenValue("uDisplay", 1, 0.03, displayId, false);
      tweenValue("uGlowNum", Math.round(percentage * 100), 0.03, countId, true);
    } else {
      tweenValue("uDisplay", 0, 0.03, displayId, false);
      tweenValue("uGlowNum", 0, 0.03, countId, true);
    }
  }
</script>
